import { theme } from 'antd';
import React from 'react';
import { Flex, Typography } from 'zui/Antd';

const { Text } = Typography;

const ErrorPersonContact = () => {
	const {
		token: { fontSizeSM, colorError }
	} = theme.useToken();

	return (
		<Flex align='flex-start' vertical gap={4}>
			<Text style={{ color: colorError, fontSize: fontSizeSM }}>
				Please enter a valid phone number, using one of the following formats:
			</Text>
			<Text style={{ color: colorError, fontSize: fontSizeSM }}>• 0412345678 (local mobile)</Text>
			<Text style={{ color: colorError, fontSize: fontSizeSM }}>• +61412345678 (international mobile)</Text>
			<Text style={{ color: colorError, fontSize: fontSizeSM }}>• 0212345678 (local landline)</Text>
			<Text style={{ color: colorError, fontSize: fontSizeSM }}>• +61212345678 (international landline)</Text>
		</Flex>
	);
};

export default ErrorPersonContact;
